import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

export const ViewAllToggle = ({ showAll, setShowAll }) => (
  <GridContainer>
    <GridItem xs={8}>
      <h3
        style={{
          margin: '30px 0px 20px 0px',
          fontWeight: '500',
          color: '#171055',
          fontSize: '15px',
          textAlign: 'right',
        }}
        onClick={() => setShowAll(true)}
      >
        {!showAll ? 'View All' : 'Reduce'}
      </h3>
    </GridItem>
    {!showAll ? (
      <GridItem xs={4}>
        <ExpandMoreIcon
          style={{
            color: '#171055',
            fontWeight: '400',
            margin: '28px 0px 0px -20px',
          }}
          onClick={() => setShowAll(true)}
        />
      </GridItem>
    ) : (
      <GridItem xs={2}>
        <ExpandLessIcon
          style={{
            color: '#171055',
            fontWeight: '400',
            margin: '28px 0px 0px -20px',
          }}
          onClick={() => setShowAll(false)}
        />
      </GridItem>
    )}
  </GridContainer>
);

export default ViewAllToggle;
